import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

// const PageConst = {

// }

const module = {
  state: {
    teacherSchedule: null,
    currentScreen: 1,
    selectedDate: null,
    C11201_getTeacherScheduleStatus: null,
  },

  getters: {

  },
  mutations: {
    setCurrentScreen(state, payload) {
      state.currentScreen = payload
    }
  },
  actions: {
    async C11201_getTeacherSchedule({ state, commit }, payload) {
      commit('setState', {
          teacherSchedule: null,
          C11201_getTeacherScheduleStatus: null
        })
      return await $this.$api.postData({
        data: {
          C11201_getTeacherSchedule:{
            api: 'T0050CalendarService.C11201_getTeacherSchedule',
            input: payload
          },
          C11201_getTeacherScheduleStatus: {
            api: 'T0050CalendarService.C11201_getTeacherScheduleStatus',
            input: payload
          }
        }
      }).then((data) => {
        commit('setState', {
          teacherSchedule: data.C11201_getTeacherSchedule.output,
          C11201_getTeacherScheduleStatus: data.C11201_getTeacherScheduleStatus.output
        })
      })
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
